import * as _ from 'lodash';

export interface PerformanceViewModel
{
    productionId: number;
    productionName: string;
    subHeading: string;
    programNotesUrl: string;
    performanceDates: Array<PerformanceSelect>;
    sections: Array<SectionSelect>;
    priceTypes: Array<PriceTypeSelection>;
    concertLandingPage: string;
    guid: string;
    splitIds: string;
    performanceId: number;
    zoneId: number;
    priceTypeId: number;
    quantity: number;
    performanceReserveFail: boolean;
    status: ErrorStatus;
    errorMessage: string;
}

export interface GroupedPerformanceModel {
    productionID: number;
    performanceModels: Array<PerformanceViewModel>;
}

export interface IProductionModels {
    performanceModels: Array<PerformanceViewModel>,
    reserveFail: boolean,
    redirectUrl: string,
    title: string,
    errorMessage: string,
    subHeading: string
}

export enum ErrorStatus {
    Section,
    Performance,
    General
}

export interface PerformanceSelect
{
    performanceId: number;
    dateTime: string;
}

export interface SectionSelect
{
    sectionId: number;
    priceTypeID: number;
    sectionDescription: string;
}

export interface PriceTypeSelection {
    priceTypeID: number;
    priceTypeDescription: string;
}

export interface ReserveRequest {
    productionId: number;
    performanceId: number;
    sectionId: number;
    quantity: number;

}


export const defaultProductionModels: IProductionModels = {
    performanceModels: [],
    reserveFail: false,
    redirectUrl: "",
    title: "",
    errorMessage: "",
    subHeading: ""
}

export const defaultPerformanceModels: Array<PerformanceViewModel> = [];


export const defaultPerformanceModel: PerformanceViewModel = {
    productionId: 0,
    performanceId: 0,
    zoneId: 0,
    priceTypeId:0,
    guid: "",
    splitIds:"",
    quantity: 0,
    productionName: "",
    subHeading: "",
    performanceDates: [],
    sections: [],
    priceTypes: [],
    concertLandingPage: "",
    performanceReserveFail: false,
    status: null,
    errorMessage: "",
    programNotesUrl: ""
}

